export default "__VITE_ASSET__CQR51hAW__"